import { findQueryBuilder } from '@/app/utils/findQueryBuilder';
import CapGeminiConsolidationImport from '@spraypaint/capgemini/CapGeminiConsolidationImport';

const findQuery = findQueryBuilder(CapGeminiConsolidationImport);
export const buildCapGeminiImportFindQuery = findQuery.buildQuery;
export const buildCapGeminiImportFindQueryLoader = findQuery.buildLoader;
export const useCapGeminiImportFindQuery = findQuery.useFindQuery;
export const buildCapGeminiImportFindQueryKeyPrefix =
  findQuery.buildQueryKeyPrefix;
